// extracted by css-extract-rspack-plugin
export default {"Cards":"Cards-module__Cards__MI7yG","Card":"Cards-module__Card__fU5m1"};